// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__12ddU","left":"styles_left__1-xmE"};